import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportDiscountsService {
  private apiUrl = environment.apiUrl + '/report_discounts/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor
  private currentFilter = new BehaviorSubject<any>(null)
  private currentDiscount = new BehaviorSubject<any>(null); // Estado reactivo
  private closeModal = new BehaviorSubject<Boolean>(false)
  currentFilter$=this.currentFilter.asObservable();
  currentDiscount$ = this.currentDiscount.asObservable();
  closeModal$ = this.closeModal.asObservable();
  setcurrentFilter(filter:any):void{
    this.currentFilter.next(filter)
  }
  getcurrentFilter():string{
    return this.currentFilter.value
  }
  setcurrentDiscount(discount:any):void{
    this.currentDiscount.next(discount)
  }
  getcurrentDiscount():string {
    return this.currentDiscount.value
  }
  setCloseModal(isclose:Boolean):any{
    this.closeModal.next(isclose)
  }
  getClosedStateModal():Boolean{
    return this.closeModal.value
  }
  clearDiscount(){
    this.currentDiscount.next(null)
  }
  get(periodId: String,userId:String): Observable<any> {
    let httpParams = new HttpParams();
    if (periodId) httpParams = httpParams.set('periodId', periodId.toString());
    if(userId) httpParams = httpParams.set('userId', userId.toString());
    return this.http.get(`${this.apiUrl}get`, { params: httpParams });
  }

  getTotalByPeriod(periodId: String): Observable<any> {
    let httpParams = new HttpParams();
    if (periodId) httpParams = httpParams.set('periodId', periodId.toString());
    return this.http.get(`${this.apiUrl}getTotalByPeriod`, { params: httpParams });
  }
  getById(id: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.http.get(this.apiUrl + 'get/' + id)
  }
  update(id: string, userData: any): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'update/' + id, userData);
  }
  save(userData: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save/', userData);
  }
  delete(id: any): Observable<any> {
    return this.http.delete(`${this.apiUrl}delete/${id}`);
  }

  generateResumeDiscounts(): Observable<any> {
    return this.http.get(`${this.apiUrl}generateResumeDiscounts`, { responseType: 'blob' });
  }

}

